module.exports = __webpack_public_path__ + "img/list-disc.744516a8.svg";